var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 916.92 271.68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{opacity:.1;}.cls-1,.cls-2{fill:#fff;}.cls-3{fill:url(#linear-gradient);}.cls-4{fill:#010101;}.cls-5{fill:#a6a5a5;}.cls-6{fill:url(#linear-gradient-3);}.cls-7{fill:url(#linear-gradient-4);}.cls-8{fill:url(#linear-gradient-2);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 139.19,
    y1: 54.65,
    x2: 139.19,
    y2: 219.92,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#267caf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#4a92b4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#79bcba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#88cebc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 224.67,
    y1: 118.19,
    x2: 204.51,
    y2: 163.78,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f48879"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#f5907a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#fbb777"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fdc874"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 194.69,
    y1: 152.86,
    x2: 104,
    y2: 226.2,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eb413d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#d94452"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#af487a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#954b92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#894a9c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 110.44,
    y1: 59.13,
    x2: 197.18,
    y2: 125.38,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#54c0ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dde79a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M910.84,239.61c0,14.37-11.65,26.02-26.03,26.02H32.14c-14.39,.01-26.07-11.63-26.09-26.02V32.1c.02-14.39,11.69-26.05,26.09-26.05H884.78c14.39,0,26.05,11.66,26.05,26.05h0V239.61h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M884.79,271.68H32.14c-17.73,0-32.1-14.35-32.14-32.07V32.11C.03,14.38,14.4,.01,32.14,0H884.78c17.73,.02,32.1,14.38,32.14,32.11V239.61c.01,17.69-14.43,32.07-32.13,32.07h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M910.84,239.61c0,14.37-11.65,26.02-26.03,26.02H32.14c-14.39,.01-26.07-11.63-26.09-26.02V32.1c.02-14.39,11.69-26.05,26.09-26.05H884.78c14.39,0,26.05,11.66,26.05,26.05h0V239.61h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M884.79,0H428.08l178.88,271.68h277.82c17.73-.01,32.1-14.37,32.14-32.09V32.11c-.03-17.73-14.4-32.09-32.14-32.11Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M324,82.13c0,5.31-1.33,9.96-4.65,13.28-3.98,3.98-8.63,5.98-14.61,5.98s-10.63-1.99-14.61-5.98c-3.98-3.98-5.98-8.63-5.98-14.61s1.99-10.63,5.98-14.61c3.98-3.98,8.63-5.98,14.61-5.98,2.66,0,5.31,.66,7.97,1.99,2.66,1.33,4.65,2.66,5.98,4.65l-3.32,3.32c-2.66-3.32-5.98-4.65-10.63-4.65-3.98,0-7.97,1.33-10.63,4.65-3.32,2.66-4.65,6.64-4.65,11.29s1.33,8.63,4.65,11.29c3.32,2.66,6.64,4.65,10.63,4.65,4.65,0,7.97-1.33,11.29-4.65,1.99-1.99,3.32-4.65,3.32-7.97h-14.61v-5.31h19.26v2.66h0Zm30.55-16.6h-17.93v12.62h16.6v4.65h-16.6v12.62h17.93v5.31h-23.24V60.88h23.24v4.65Zm21.92,35.2h-5.31v-35.2h-11.29v-4.65h27.89v4.65h-11.29v35.2Zm30.55,0V60.88h5.31v39.85h-5.31Zm27.89,0h-5.31v-35.2h-11.29v-4.65h27.23v4.65h-11.29v35.2h.66Zm63.09-5.31c-3.98,3.98-8.63,5.98-14.61,5.98s-10.63-1.99-14.61-5.98c-3.98-3.98-5.98-8.63-5.98-14.61s1.99-10.63,5.98-14.61c3.98-3.98,8.63-5.98,14.61-5.98s10.63,1.99,14.61,5.98c3.98,3.98,5.98,8.63,5.98,14.61s-1.99,10.63-5.98,14.61Zm-25.24-3.32c2.66,2.66,6.64,4.65,10.63,4.65s7.97-1.33,10.63-4.65c2.66-2.66,4.65-6.64,4.65-11.29s-1.33-8.63-4.65-11.29c-2.66-2.66-6.64-4.65-10.63-4.65s-7.97,1.33-10.63,4.65c-2.66,2.66-4.65,6.64-4.65,11.29s1.33,8.63,4.65,11.29Zm38.52,8.63V60.88h5.98l19.26,31.21v-31.21h5.31v39.85h-5.31l-20.59-32.54v32.54h-4.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M461.46,150.53c-15.94,0-28.56,11.95-28.56,28.56s12.62,28.56,28.56,28.56,28.56-11.95,28.56-28.56-12.62-28.56-28.56-28.56Zm0,45.16c-8.63,0-15.94-7.31-15.94-17.27s7.31-17.27,15.94-17.27,15.94,6.64,15.94,17.27c0,9.96-7.31,17.27-15.94,17.27Zm-61.76-45.16c-15.94,0-28.56,11.95-28.56,28.56s12.62,28.56,28.56,28.56,28.56-11.95,28.56-28.56-12.62-28.56-28.56-28.56Zm0,45.16c-8.63,0-15.94-7.31-15.94-17.27s7.31-17.27,15.94-17.27,15.94,6.64,15.94,17.27c0,9.96-7.31,17.27-15.94,17.27Zm-73.71-36.53v11.95h28.56c-.66,6.64-3.32,11.95-6.64,15.27-3.98,3.98-10.63,8.63-21.92,8.63-17.93,0-31.21-13.95-31.21-31.88s13.95-31.88,31.21-31.88c9.3,0,16.6,3.98,21.92,8.63l8.63-8.63c-7.31-6.64-16.6-11.95-29.88-11.95-23.91,0-44.49,19.92-44.49,43.83s20.59,43.83,44.49,43.83c13.28,0,22.58-3.98,30.55-12.62,7.97-7.97,10.63-19.26,10.63-27.89,0-2.66,0-5.31-.66-7.31h-41.17Zm301.5,9.3c-2.66-6.64-9.3-17.93-23.91-17.93s-26.56,11.29-26.56,28.56c0,15.94,11.95,28.56,27.89,28.56,12.62,0,20.59-7.97,23.24-12.62l-9.3-6.64c-3.32,4.65-7.31,7.97-13.95,7.97s-10.63-2.66-13.95-8.63l37.85-15.94-1.33-3.32h0Zm-38.52,9.3c0-10.63,8.63-16.6,14.61-16.6,4.65,0,9.3,2.66,10.63,5.98l-25.24,10.63h0Zm-31.21,27.23h12.62V121.97h-12.62v83.01Zm-19.92-48.48c-3.32-3.32-8.63-6.64-15.27-6.64-13.95,0-27.23,12.62-27.23,28.56s12.62,27.89,27.23,27.89c6.64,0,11.95-3.32,14.61-6.64h.66v3.98c0,10.63-5.98,16.6-15.27,16.6-7.31,0-12.62-5.31-13.95-9.96l-10.63,4.65c3.32,7.31,11.29,16.6,25.24,16.6s26.56-8.63,26.56-29.22v-50.47h-11.95v4.65h0Zm-14.61,39.18c-8.63,0-15.94-7.31-15.94-17.27s7.31-17.27,15.94-17.27,15.27,7.31,15.27,17.27-6.64,17.27-15.27,17.27Zm162.04-73.71h-29.88v83.01h12.62v-31.21h17.27c13.95,0,27.23-9.96,27.23-25.9s-13.28-25.9-27.23-25.9Zm.66,39.85h-17.93v-28.56h17.93c9.3,0,14.61,7.97,14.61,13.95-.66,7.31-5.98,14.61-14.61,14.61h0Zm76.37-11.95c-9.3,0-18.59,3.98-21.92,12.62l11.29,4.65c2.66-4.65,6.64-5.98,11.29-5.98,6.64,0,12.62,3.98,13.28,10.63v.66c-1.99-1.33-7.31-3.32-12.62-3.32-11.95,0-23.91,6.64-23.91,18.59,0,11.29,9.96,18.59,20.59,18.59,8.63,0,12.62-3.98,15.94-7.97h.66v6.64h11.95v-31.88c-1.33-14.61-12.62-23.24-26.56-23.24h0Zm-1.33,45.82c-3.98,0-9.96-1.99-9.96-7.31,0-6.64,7.31-8.63,13.28-8.63,5.31,0,7.97,1.33,11.29,2.66-1.33,7.97-7.97,13.28-14.61,13.28Zm69.73-43.83l-13.95,35.86h-.66l-14.61-35.86h-13.28l21.92,50.47-12.62,27.89h12.62l33.87-78.36h-13.28Zm-111.57,53.13h12.62V121.97h-12.62v83.01Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M98.68,55.13c-1.99,1.99-2.66,5.31-2.66,9.3V211.19c0,3.98,1.33,7.31,3.32,9.3l.66,.66,82.35-82.35v-1.33L98.68,55.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M208.92,166.7l-27.23-27.23v-1.99l27.23-27.23,.66,.66,32.54,18.59c9.3,5.31,9.3,13.95,0,19.26l-33.2,17.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M209.59,166.03l-27.89-27.89-83.01,83.01c3.32,3.32,7.97,3.32,13.95,.66l96.96-55.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M209.59,110.25L112.63,55.13c-5.98-3.32-10.63-2.66-13.95,.66l83.01,82.35,27.89-27.89h0Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.d95d4e6db9b4a146cac0d3ce5372c304.svg";
export { ForwardRef as ReactComponent };